import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Recommendations.css';
import Lottie from 'lottie-react';
import hotelAnimation from '../json-lottie/hotel.json';
import foodAnimation from '../json-lottie/carr.json';

function Recommendations() {
    const { t } = useLanguage();
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const cardContainerRef = React.useRef(null);

    const scrollToCard = (index) => {
        if (cardContainerRef.current) {
            const cards = cardContainerRef.current.querySelectorAll('.cards-recommendations');
            if (cards[index]) {
                cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                setCurrentCardIndex(index);
            }
        }
    };

    // Track which card is in view
    useEffect(() => {
        if (!cardContainerRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                        const cards = Array.from(cardContainerRef.current.querySelectorAll('.cards-recommendations'));
                        const index = cards.indexOf(entry.target);
                        if (index !== -1) {
                            setCurrentCardIndex(index);
                        }
                    }
                });
            },
            { threshold: 0.5, root: cardContainerRef.current }
        );

        const cards = cardContainerRef.current.querySelectorAll('.cards-recommendations');
        cards.forEach((card) => observer.observe(card));

        return () => observer.disconnect();
    }, []);

    const [showPdfModal, setShowPdfModal] = useState(false);
    const pdfUrl = "info_BarceloCDMX.pdf"; // Placeholder PDF file

    const togglePdfModal = () => {
        setShowPdfModal(!showPdfModal);
    };

    return (
        <div className='recommendations'>
            <h2>{t.recommendations_title}</h2>

            <div className="card-container-recommendations" ref={cardContainerRef}>
                {/* Navigation Arrows */}
                {currentCardIndex > 0 && (
                    <button
                        className="nav-arrow left"
                        onClick={() => scrollToCard(currentCardIndex - 1)}
                        aria-label="Previous card"
                    >
                        &#10094;
                    </button>
                )}

                {currentCardIndex < 1 && (
                    <button
                        className="nav-arrow right"
                        onClick={() => scrollToCard(currentCardIndex + 1)}
                        aria-label="Next card"
                    >
                        &#10095;
                    </button>
                )}

                {/* Hotel/Accomodation Card */}
                <div className="cards-recommendations">
                    <div className="card-title">{t.card_hotel_title}</div>
                    <Lottie animationData={hotelAnimation} style={{ width: 190, height: 120 }} />
                    <h1 className="card-header1">{t.card_hotel_header1}</h1>
                    <h3 className="card-header2">{t.card_hotel_header2}</h3>
                    <button className="recommendations-btn" onClick={togglePdfModal}>{t.btn_view_info}</button>
                </div>

                <div className="cards-recommendations">
                    <div className="card-title">{t.card_transport_title}</div>
                    <Lottie animationData={foodAnimation} style={{ width: 190, height: 120 }} />
                    <h1 className="card-header1">{t.card_transport_header1}</h1>
                    <h3 className="card-header2">{t.card_transport_header2}</h3>
                </div>
            </div>

            {/* PDF Modal */}
            {showPdfModal && (
                <div className="pdf-modal-overlay" onClick={togglePdfModal}>
                    <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="pdf-modal-close" onClick={togglePdfModal}>&times;</button>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                            <a href={pdfUrl} download className="recommendations-btn" style={{ marginTop: 0, textDecoration: 'none', display: 'inline-block' }}>
                                {t.btn_download_pdf || "Download PDF"}
                            </a>
                        </div>
                        <iframe
                            src={pdfUrl}
                            title="Hotel Info PDF"
                            className="pdf-iframe"
                            width="100%"
                            height="100%"
                        >
                            <p>{t.pdf_fallback} <a href={pdfUrl} download>{t.pdf_download_link}</a>.</p>
                        </iframe>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Recommendations;
